import { createSelector } from 'reselect';
import { userIdState } from '../redux/UserIdState.js';
export const isUserIdSet = createSelector(userIdState, (state) => typeof state.data !== 'undefined');
export const getUserId = createSelector([userIdState, isUserIdSet], (state, loaded) => (loaded ? state.data : ''));
//# sourceMappingURL=selectors.js.map